import api from "../atlasApi";

export const serviceComment = (data) => {
  return api.post("/horizon/add-review/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};

export const serviceGetComment = (data) => {
  return api.post("/horizon/get-review/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};

export const serviceGetReviewTitles = (data) => {
  return api.post("/horizon/get-review-types/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};
